import { withTranslate } from "@pathwright/ui/src/components/"
import { i18n } from "@pathwright/ui/src/components/lng/I18nextProvider"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import View from "@pathwright/ui/src/components/ui/View"
import {
  OFFERING_OPTION_IN_PLAN,
  OFFERING_OPTION_NOT_IN_PLAN
} from "library/register/constants"
import React from "react"
import styled from "styled-components"

const StyledView = styled(View)`
  display: flex;
  align-items: baseline;
  ${(p) => (p.$hasMultipleOptions ? "cursor: pointer;" : "")}

  input {
    margin-right: 10px;
  }
`

const tPrefix = "resource.offering_form"

class ResourceOfferingForm extends React.Component {
  // invoked if offering is free or has price option
  constructor(...args) {
    super(...args)
    this.renderPurchaseOption = this.renderPurchaseOption.bind(this)
    this.renderSubscriptionOption = this.renderSubscriptionOption.bind(this)
    this.renderAlreadyIncluded = this.renderAlreadyIncluded.bind(this)
  }

  renderPurchaseOption() {
    const {
      offeringOption,
      resource_type,
      hasMultipleOptions,
      onSelect,
      selection,
      t,
      Trans
    } = this.props

    const resourceTypeDisplay = t(`resource.types.${resource_type}`)

    return (
      <StyledView
        paddingBottom
        onClick={() => onSelect(offeringOption)}
        $hasMultipleOptions={hasMultipleOptions}
      >
        {hasMultipleOptions && (
          <input
            type="radio"
            onChange={(e) => onSelect(offeringOption)}
            checked={
              selection && selection.option === OFFERING_OPTION_NOT_IN_PLAN
            }
          />
        )}
        {/* Supporting legacy `for_resource` translation */}
        {i18n.exists(`${tPrefix}.for_resource`) ? (
          <Text.H5>
            <b>{offeringOption.display_price} </b>
            {offeringOption.display_price !== t(`${tPrefix}.free`) &&
              offeringOption.display_price !== "Free" && (
                <span>
                  {t(`${tPrefix}.for_resource`, {
                    resource_type: resourceTypeDisplay
                  })}
                </span>
              )}
          </Text.H5>
        ) : (
          <Text.H5>
            {offeringOption.display_price !== t(`${tPrefix}.free`) ? (
              <Trans
                i18nKey={`${tPrefix}.one_time_price_for_path`}
                tOptions={{
                  price: `<strong>${offeringOption.display_price}</strong>`
                }}
                parent="span"
                components={{
                  strong: <strong />
                }}
              />
            ) : (
              <b>{offeringOption.display_price}</b>
            )}
          </Text.H5>
        )}
      </StyledView>
    )
  }

  // invoked if offering is included in school subscription planOptions(s)
  renderSubscriptionOption() {
    const {
      offeringOption,
      planOptions,
      resource_type,
      hasMultipleOptions,
      planOption,
      onSelect,
      selection,
      Trans,
      t
    } = this.props

    const resourceTypeDisplay = t(`resource.types.${resource_type}`)

    return (
      <StyledView
        paddingBottom
        onClick={() => onSelect(planOption)}
        $hasMultipleOptions={hasMultipleOptions}
      >
        {hasMultipleOptions ? (
          <input
            type="radio"
            onChange={(e) => onSelect(planOption)}
            checked={selection && selection.option === OFFERING_OPTION_IN_PLAN}
          />
        ) : undefined}

        {/* Supporting legacy `access_resource` and `cost_for_resource` translations */}
        {i18n.exists(`${tPrefix}.access_resource`) &&
        i18n.exists(`${tPrefix}.cost_for_resource`) ? (
          <Text.H5>
            {planOptions.length > 1 ? (
              // prettier-ignore
              // Trans formatting integral to translation json!
              <Trans parent="span" i18nKey={`${tPrefix}.access_resource`}>
              Access this{" "}
              {{ resourceTypeDisplay }}{" "}
              and more for as little as{" "}
              <b>{{ planDisplayPrice: planOption.display_price }}</b>
              {/* NOTE: only including a space char when not using legacy "/<interval>" translation. */}
              {{ planDisplayInterval: `${planOption.display_interval.startsWith("/") ? "" : " "}${planOption.display_interval}` }}
            </Trans>
            ) : (
              // prettier-ignore
              // Trans formatting integral to translation json!
              <Trans parent="span" i18nKey={`${tPrefix}.cost_for_resource`}>
              <b>{{ planDisplayPrice: planOption.display_price }}</b>
              {{ planDisplayInterval: `${planOption.display_interval.startsWith("/") ? "" : " "}${planOption.display_interval}` }}
              {{ resourceTypeDisplay }}
              {{
                includedResourcesCount:
                  planOption.resources_count == null ?
                  ` & ${t(`${tPrefix}.others`)}`
                  : planOption.resources_count - 1 > 0
                    ? ` & ${planOption.resources_count - 1} ${t(
                        `${tPrefix}.others`
                      )}`
                    : ""
              }}
            </Trans>
            )}
          </Text.H5>
        ) : (
          <Text.H5>
            <Trans
              i18nKey={`${tPrefix}.subscription_price_for_path`}
              tOptions={{
                prices: planOptions.map(
                  (planOption) =>
                    `<strong>${planOption.display_price}${
                      // NOTE: only including a space char when not using legacy "/<interval>" translation.
                      planOption.display_interval.startsWith("/") ? "" : " "
                    }${planOption.display_interval}</strong>`
                )
              }}
              parent="span"
              components={{
                strong: <strong />
              }}
            />
          </Text.H5>
        )}
      </StyledView>
    )
  }

  // invoked if offering in included in a user subscription
  renderAlreadyIncluded() {
    const { t, isIncludedInGroupSubscription, isMultiSeatGroupSubscription } =
      this.props

    return (
      <View paddingBottom>
        <Pathicon icon="check" />{" "}
        {t(`${tPrefix}.included`, {
          subscription:
            isIncludedInGroupSubscription && isMultiSeatGroupSubscription
              ? t("group subscription")
              : t("subscription")
        })}
      </View>
    )
  }

  render() {
    const {
      offeringOption,
      planOption,
      isIncludedInUserSubscription,
      isIncludedInGroupSubscription,
      hasMultipleOptions
    } = this.props

    return isIncludedInUserSubscription || isIncludedInGroupSubscription ? (
      this.renderAlreadyIncluded()
    ) : offeringOption || planOption ? (
      <div
        className={
          hasMultipleOptions
            ? "ResourceOfferingForm__multiple-options"
            : undefined
        }
      >
        {offeringOption ? this.renderPurchaseOption() : undefined}
        {planOption ? this.renderSubscriptionOption() : undefined}
      </div>
    ) : null
  }
}

ResourceOfferingForm.displayName = "ResourceOfferingForm"
export default withTranslate(ResourceOfferingForm)
